import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/analisis",
    label: "Análisis",
    isActive: true,
  },
];

function Analisis() {
  return (
    <Page title="Análisis" description="Panel de análisis." breadCrumbs={breadCrumbs}>
      <CardSection />
    </Page>
  );
}

export default Analisis;
